import React, { useCallback, useEffect, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import clsx from 'clsx';

import { useDomainProperties } from 'hooks/useDomainProperties';

function Logo({ logo }) {
  return <img className="mb-5" src={logo || '/images/logo-blanco.svg'} style={{ width: '70%' }} alt="" />
}

function SlackLogo({ }) {
  return (
    <div class="d-flex mb-5">
      <div class="text-center">
        <img id="trato-logo" alt="" class="align-self-center mt-1 w-20" src="/images/owl-logo.svg" width="20%" />
        <span class="align-self-center mx-3 d-inline-block lead"><i class="fas fa-exchange-alt text-light align-self-center align-bottom"></i></span>
        <img id="trato-logo" alt="" class="align-self-center w-20" src="/images/slack.svg" width="20%" />
      </div>
    </div>
  )
}


export default function AuthLayout({ children, isSlack }) {

  const { domain } = useDomainProperties();
  const { token } = useParams();
  const history = useHistory();

  useEffect(() => {
      if (token) {
          localStorage.setItem('jwt', token);
          history.push('/login')
      }
  }, [token])

  return (
      <div className={clsx('login-container h-100 d-flex', domain.logo ? 'bg-dashboard' : 'bg-secondary')}>
          <div className="form-signin">
              <div className="text-center">
                {isSlack ? (
                  <SlackLogo />
                ) : (
                  <Logo logo={domain.logo} />
                )}
              </div>
              {children}
              <div className="text-center">
                {domain.logo && <img src="/images/powered-by-trato.png" alt="Powered by Trato" className="mt-5" />}
              </div>
              
          </div>
      </div>
  )
}
